import { AppContext, getDefaultRowCount } from '@nile/components';
import { useRef, useContext } from 'react';
import { savePersonalization } from '@nile/graphql';

/*
BE CAREFUL WHILE SAVING JSON AS IT'LL REWRITE OTHER PERSONALIZATION

JSON = {
      allTableRowCount: {
        invoiceTable: 50,
        taxTable: 100,
      }
      allTableColumnOptions ;{
        ......
      }
      allTableSorting:{
        [tableName]:{
          [viewId OR 'default'] : [sort]
        }
      }
    }
*/

const getTablePersonalizationObject = () => {
  const appContext = useContext(AppContext);
  const tablePersonalization = appContext?.tablePersonalization;
  let value = null;
  if (tablePersonalization?.value) {
    value = JSON.parse(tablePersonalization?.value);
  }
  return value;
};

let tablePersonalizationObject = null;
let updatedPersonalization = null;

// FOR ROW COUNT
let rowCountObject = null;
let updatedRowCountObject = null;

// FOR COLUMN WIDTH
const DEFAULT_COLUMN_WIDTH = 150;
let columnWidthObject = null;
let updatedColumnWidthObject = null;
let tableColumns = null; // Returns columnWidth for particular table
let updatedSorting = null;

// REFACTOR: FUNCTION TO PREVENT DATA OVERWRITE ON PERSONALIZATION
const saveToPersonalization = (user, object) => {
  /*
  SAVE PERSONALIZATION JSON STRUCTURE 
  user: {
      firstName: currentUser.firstName,
      userId: currentUser?.userId,
      email: currentUser?.email,
      lastName: currentUser?.lastName
    },
    category: 'tableViewsPersonalization',
    name: currentUser?.userId,
    value: {
      allTableRowCount: {
        invoiceTable: 50,
        taxTable: 100,
      }
      allTableColumnOptions: {
        ......
      }
    }  
  */
  if (updatedPersonalization) {
    updatedPersonalization = { ...updatedPersonalization, ...object };
  } else {
    updatedPersonalization = { ...tablePersonalizationObject, ...object };
  }
  const currentUser = user;
  const variables = {
    user: {
      firstName: currentUser.firstName,
      userId: currentUser?.userId,
      email: currentUser?.email,
      lastName: currentUser?.lastName
    },
    category: 'tableViewPersonalization',
    name: currentUser?.userId,
    value: JSON.stringify(updatedPersonalization)
  };

  savePersonalization({
    variables: variables,
    input: variables
  });
};
// END: FUNCTION TO PREVENT DATA OVERWRITE ON PERSONALIZATION

const getTableRowCount = (tableName) => {
  tablePersonalizationObject = getTablePersonalizationObject();
  let rowCount = getDefaultRowCount(tableName);

  if (tablePersonalizationObject?.allTableRowCount) {
    rowCountObject = tablePersonalizationObject?.allTableRowCount;
  }

  if (
    updatedRowCountObject &&
    JSON.stringify(updatedRowCountObject) !== JSON.stringify(rowCountObject)
  ) {
    rowCountObject = updatedRowCountObject;
  }
  if (rowCountObject && rowCountObject[tableName]) {
    rowCount = rowCountObject[tableName];
  }
  return rowCount;
};

const saveTableRowCount = (tableName, rowCount, user) => {
  updatedRowCountObject = { ...rowCountObject, [tableName]: rowCount };
  saveToPersonalization(user, { allTableRowCount: updatedRowCountObject });
};

const getAllColumnWidth = (tableName) => {
  tablePersonalizationObject = getTablePersonalizationObject();

  if (tablePersonalizationObject?.allTableColumnWidth) {
    columnWidthObject = tablePersonalizationObject?.allTableColumnWidth;
  }

  if (updatedColumnWidthObject && updatedColumnWidthObject[tableName]) {
    tableColumns = updatedColumnWidthObject[tableName];
  } else if (columnWidthObject && columnWidthObject[tableName]) {
    tableColumns = columnWidthObject[tableName];
  }
  return tableColumns;
};

const getColumnWidth = (object, key, override) => {
  let defaultColumnWidth = override || DEFAULT_COLUMN_WIDTH;
  if (object && object[key]) {
    defaultColumnWidth = object[key];
  }

  return defaultColumnWidth;
};

const saveColumnWidth = (tableName, user, colName, value) => {
  tableColumns = { ...tableColumns, [colName]: value };
  if (updatedColumnWidthObject) {
    updatedColumnWidthObject = {
      ...updatedColumnWidthObject,
      [tableName]: tableColumns
    };
  } else {
    updatedColumnWidthObject = {
      ...columnWidthObject,
      [tableName]: tableColumns
    };
  }

  saveToPersonalization(user, {
    allTableColumnWidth: updatedColumnWidthObject
  });
};
const saveSortingPersonalization = (
  tableName,
  user,
  sortingData = [],
  viewId = 'default'
) => {
  if (updatedSorting) {
    updatedSorting = {
      ...updatedSorting,
      [tableName]: { ...updatedSorting[tableName], [viewId]: sortingData }
    };
  } else {
    updatedSorting = {
      ...tablePersonalizationObject?.allTableSorting,
      [tableName]: {
        ...tablePersonalizationObject?.allTableSorting?.[tableName],
        [viewId]: sortingData
      }
    };
  }
  saveToPersonalization(user, {
    allTableSorting: updatedSorting
  });
};
const getPersonalizedSorting = (tableName, viewId = 'default') => {
  if (updatedSorting?.[tableName]?.[viewId]) {
    return updatedSorting?.[tableName]?.[viewId];
  }

  if (!tablePersonalizationObject) {
    tablePersonalizationObject = getTablePersonalizationObject();
  }
  if (tablePersonalizationObject?.allTableSorting?.[tableName]?.[viewId]) {
    return tablePersonalizationObject?.allTableSorting?.[tableName]?.[viewId];
  }
  return null;
};
export {
  getTableRowCount,
  saveTableRowCount,
  getAllColumnWidth,
  getColumnWidth,
  saveColumnWidth,
  saveSortingPersonalization,
  getPersonalizedSorting
};
